export const ModifyFaceOffResult = {
  name: "modify-faceoff-result",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.faceOff.success",
  showOn: [{ state: "editState", value: "faceoff-result", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "faceoff_result_description",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [true],
      options: {
        layout: "description-text",
        text: "edit.faceOff.success.description",
      },
      actionGroups: [],
    },
    {
      name: "confirm-panel",
      component: "SubPanel",
      layout: "sub-panel",
      mode: "visible",
      text: null,
      showOn: [true],
      children: [
        {
          name: "ok-button",
          component: "TypeButton",
          layout: "match-button action",
          mode: "enable",
          text: "ok",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                {
                  action: "switchValuesPlay",
                  value: {
                    eventType: "faceOff",
                    property: "subType",
                    values: ["won", "lost"],
                  },
                  type: "main",
                },
                {
                  action: "nextState",
                  value: null,
                  type: "editState",
                },
              ],
              conditions: [],
            },
          ],
        },
      ],
    },
  ],
};
